import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/ProductActions";

const initialState = {
  status: 200,
  isLoading: false,
  isSaving: false,
  message: "",
  header: {},
  data: [],
  dataProduct: [],
  dataResume: {},
  usersStatus: [],
  lastPage: false,
  alldata: [],
};

const ProductStore = useGlobalHook(React, initialState, actions);

export default ProductStore;
